module.exports = __webpack_public_path__ + "img/GAME_NATIONWIDETOUR2.7c5539d9.jpg";